import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import "./ckeditor"
import "@fortawesome/fontawesome-free/js/all.js"

import "trix"
import "@rails/actiontext"

import "./jquery-3.7.1.min"
import "./popper.min"
import "./jquery.scrollbar.min"
import "./demo"

import "chartkick/chart.js"

import 'datatables.net-bs5';
import 'datatables.net-responsive-bs5';
import 'datatables.net-buttons-bs5';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';

document.addEventListener("turbo:load", () => {
  document.querySelectorAll(".toast").forEach((toastEl) => {
    const toast = new bootstrap.Toast(toastEl);
    toast.show();
  });
});


